<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';

const warnings = ref([
    { size: '10rem', opacity: 0.1, speed: 0.02, position: { top: '25%', left: '15%' }, animClass: 'warning2' },
    { size: '12rem', opacity: 0.2, speed: 0.01, position: { top: '60%', left: '5%' }, animClass: 'warning1' },
    { size: '19rem', opacity: 0.3, speed: -0.008, position: { bottom: '5%', right: '5%' }, animClass: 'warning3' },
    { size: '8rem', opacity: 0.1, speed: -0.02, position: { bottom: '5%', right: '15%' }, animClass: 'warning1' }
]);

const handleScroll = () => {
    const elements = document.querySelectorAll('.parallax-icon');
    elements.forEach((el) => {
        const speed = parseFloat(el.getAttribute('data-speed'));
        el.style.transform = `translateY(${window.scrollY * speed}px)`;
    });
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
});

onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
    <div>
        <div
            v-for="(icon, index) in warnings"
            :key="index"
            :class="['parallax-icon', icon.animClass, 'fixed', 'pointer-events-none', '-z-10']"
            :style="icon.position"
            :data-speed="icon.speed"
        >
            <i class="fi fi-ss-triangle-warning text-red" :style="{ fontSize: icon.size, opacity: icon.opacity, display: 'inline-block' }"></i>
        </div>
    </div>
</template>

<style>
@keyframes float1 {
    0%,
    100% {
        transform: rotate(-15deg) translateY(0);
    }
    50% {
        transform: rotate(-15deg) translateY(-20px);
    }
}
@keyframes float2 {
    0%,
    100% {
        transform: rotate(5deg) translate(0, 0);
    }
    50% {
        transform: rotate(0deg) translate(15px, -15px);
    }
}
@keyframes float3 {
    0%,
    100% {
        transform: rotate(10deg) translate(0, 0);
    }
    50% {
        transform: rotate(10deg) translate(25px, -45px);
    }
}

.video-section .warning1,
.parallax-icon.warning1 {
    animation: float1 15s ease-in-out infinite;
}
.video-section .warning2,
.parallax-icon.warning2 {
    animation: float2 15s ease-in-out infinite;
}
.video-section .warning3,
.parallax-icon.warning3 {
    animation: float3 15s ease-in-out infinite;
}
</style>
